export default "__VITE_ASSET__8e5612a7__"